export const checkIfObject = (data: any) =>
  typeof data === "object" && data !== null && !Array.isArray(data);
